import { render, staticRenderFns } from "./payment_confirmation.vue?vue&type=template&id=5ca9570c&scoped=true&"
import script from "./payment_confirmation.vue?vue&type=script&lang=js&"
export * from "./payment_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca9570c",
  null
  
)

export default component.exports